import { Icons } from './icons'; // if using ES modules

document.addEventListener('DOMContentLoaded', function() {
    

    // Insert icons into their respective section headings
    const musicSectionHeading = document.querySelector('.music-section h2');
    const wineSectionHeading = document.querySelector('.wine-section h2');
    const weedSectionHeading = document.querySelector('.weed-section h2');

    if (musicSectionHeading) {
      musicSectionHeading.insertBefore(Icons.get('music'), musicSectionHeading.firstChild);
    }
    if (wineSectionHeading) {
      wineSectionHeading.insertBefore(Icons.get('wine'), wineSectionHeading.firstChild);
    }
    if (weedSectionHeading) {
      weedSectionHeading.insertBefore(Icons.get('weed'), weedSectionHeading.firstChild);
    }

    function updateVivinoLinks() {
        // Get the container with id "from-vivino"
        const container = document.getElementById("from-vivino");
        if (!container) return;
      
        // Select all <a> tags inside the container
        const links = container.querySelectorAll("a");
      
        // Prepend the base URL to the href of each link
        links.forEach(link => {
          // Ensure the href exists before updating
          const href = link.getAttribute("href");
          if (href) {
            link.setAttribute("href", "https://www.vivino.com" + href);
            link.setAttribute("target", "_blank");
          }
        });
      }
      updateVivinoLinks()
});